<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
            <div v-if="ifelse == '1'">
                    <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
                    <el-form-item label="选择员工" >
                        <el-input v-model="formLabelAlign.userName" size="small" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="归属公司">
                        <el-input v-model="formLabelAlign.companyName" size="small" disabled></el-input>
                    </el-form-item>
                        <el-form-item label="归属部门">
                        <el-input v-model="formLabelAlign.officeName" size="small" disabled></el-input>
                    </el-form-item>
                        <el-form-item label="外包公司">
                        <el-input v-model="formLabelAlign.userOutCompanyName" size="small" disabled></el-input>
                    </el-form-item>
                        <el-form-item label="工号">
                        <el-input v-model="formLabelAlign.userNo" size="small" disabled></el-input>
                    </el-form-item>
                        <el-form-item label="邮箱">
                        <el-input v-model="formLabelAlign.userEmail" size="small" disabled></el-input>
                    </el-form-item>
                            <el-form-item label="电话">
                        <el-input v-model="formLabelAlign.userPhone" size="small" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="手机">
                        <el-input v-model="formLabelAlign.mobile" size="small" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="登录名">
                        <el-input v-model="formLabelAlign.loginName" size="small" ></el-input>
                    </el-form-item>
                        <el-form-item label="密码">
                        <el-input show-password @blur="ValidatePassword()" v-model="password" size="small" style="width:180px" placeholder="若不修改密码，请留空"></el-input>
                        <el-button size="small" @click="Random()">随机</el-button>
                    </el-form-item>
                        <el-form-item label="确认密码">
                        <el-input show-password style="width:180px" @blur="ConfirmPassword()" v-model="AgainPassword" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="用户类型">
                    <el-select  clearable v-model="userTypeVal" placeholder="请选择">
                        <el-option
                        v-for="item in userType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="用户权限">
                    <el-select  clearable
                        @change="userRightChange(userRightVal)"
                        v-model="userRightVal"
                        multiple
                        collapse-tags
                        placeholder="请选择">
                        <el-option
                        v-for="item in userRight"
                        :key="item.roleId"
                        :label="item.roleName"
                        :value="item.roleId">
                        </el-option>
                    </el-select>
                    </el-form-item>
                    </el-form>
            </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UserManDialog",
  data() {
    return {
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     ifelse:'1',
     formLabelAlign:{},

     userType:[],
     userTypeVal:"",

     userRight:[],
     userRightVal:"",

     mobileCode:"",
     password:"",
     AgainPassword:'',

    };
  },
  methods: {
      Random(){
          var Num="";
            for(var i=0;i<6;i++)
            {
            Num+=Math.floor(Math.random()*10);
            }
            this.password = Num
            this.AgainPassword = Num
             this.$alert("随机密码:"+Num, '随机密码', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      },
      userRightChange(val){
      },
      modification(){
          let obj = {
              "userId":this.formLabelAlign.userId,
              "roleList":this.userRightVal,
              "loginName":this.formLabelAlign.loginName,
              "password":this.password,
              "userType":this.userTypeVal
          }
          this.$http.post(this.$requestUrl.POST_USER_SEVE,obj).then((res)=>{
              console.log(res)
              if(res.data.code == 200){
                  this.dialogVisible = false
              }else{
                   this.$message.error(result.msg)
              }
           }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
      },
      ValidatePassword(){
            let reg_pass = /^[\x00-\xff]+$/
            let password = this.password
            if(password.length>4 && password.length<19){
               if(!reg_pass.test(password)){
                    this.$message({
                        type: "warning",
                        message: "当前密码不符合规则，请重新输入"
                    })
                    this.password = ""
                }
            }else{
                    this.$message({
                        type: "warning",
                        message: "当前密码不符合规则，请重新输入"
                    })
                this.password = ""
            }
      },
      ConfirmPassword(){
      let password = this.password
      let AgainPassword = this.AgainPassword
      if(password === AgainPassword){}else{this.$message({ type: "warning",message: "两次密码输入不一致"})
        this.AgainPassword = ""
      }
      },
    handleClose(done) {
      this.dialogVisible = false
    },

  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      let obj = {
          "userName":"",
          "companyName":"",
          "officeName":'',
          "name":"",
          "mobile":"",
          "loginName":"",
      }
      this.formLabelAlign = obj
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>